module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-96x96-de341923c401b81cf37e2e69fac0af8d.png";